<template>
  <div>
    <hr class="w-full my-lg" />
    <div class="flex flex-wrap justify-between gap-base">
      <BaseButton
        v-if="onBack"
        @click.native="onBack"
        variant="secondary"
        :data-ec="buttonDataEc"
        :data-et="backButtonDataEt"
      >
        {{ isEditRoute || isEditStepRoute ? $t('functional.cancel') : $t('functional.back') }}
      </BaseButton>

      <div class="contents sm:flex sm:flex-row-reverse sm:gap-lg sm:ml-auto">
        <BaseButton
          v-if="showNext"
          @click.native="onNext"
          :disabled="!onNext || isDisabled || isBusyOnNext"
          :loading="isBusyOnNext"
          class="ml-auto"
          :data-ec="buttonDataEc"
          :data-et="nextButtonDataEt"
        >
          {{ isEditRoute ? $t('functional.update') : $t('functional.next') }}
        </BaseButton>

        <div class="flex justify-end w-full sm:contents">
          <BaseButton
            v-if="onSave !== undefined"
            @click.native="onSave"
            :disabled="!onSave || isDisabled || isBusyOnSave"
            :loading="isBusyOnSave"
            variant="invisible"
            class="!px-0"
            :data-ec="buttonDataEc"
            data-et="save_draft_button"
          >
            {{ $t('ui.bulkSend.stepsNavigation.saveAsDraft') }}
          </BaseButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import useBulkSendRoutes from '@/composables/bulkSend/routes';

import BaseButton from '@/components/library/buttons/BaseButton.vue';

export default {
  name: 'StepsNavigation',
  components: { BaseButton },
  props: {
    onBack: {
      type: Function,
      required: false,
    },
    onSave: {
      type: [Function, Boolean],
      required: false,
      default: undefined,
    },
    isBusyOnSave: {
      type: Boolean,
      required: false,
      default: false,
    },
    onNext: {
      type: [Function, Boolean],
      required: false,
    },
    isBusyOnNext: {
      type: Boolean,
      required: false,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    showNext: {
      type: Boolean,
      required: false,
      default: true,
    },
    buttonDataEc: {
      type: String,
      required: true,
    },
  },
  setup() {
    const { isEditRoute, isEditStepRoute } = useBulkSendRoutes();
    return { isEditRoute, isEditStepRoute };
  },
  computed: {
    backButtonDataEt() {
      return this.isEditRoute || this.isEditStepRoute ? 'cancel_button' : 'back_button';
    },
    nextButtonDataEt() {
      return this.isEditRoute ? 'update_button' : 'next_button';
    },
  },
};
</script>
